import { MutationTree } from "vuex";
import { IReferenceDataState, IReferenceDataTypes } from "./types";

export namespace REFERENCE_DATA_MUTATIONS {
  export const TOGGLE_IS_LOADING = "toggleIsLoading";
  export const SET_REFERENCE_DATA = "setReferenceData";
  export const ADD_REFERENCE_DATA_ITEM = "addReferenceDataItem";
  export const SET_ADD_NEW_DIALOG_ERROR_MESSAGE =
    "setAddReferenceDataDialogErrorMessage";
  export const SET_BANKS_DATA = "setBanksData";
  export const SET_DATA_TABLE_PAGINATION = "setDataTablePagination";
}

export const mutations: MutationTree<IReferenceDataState> = {
  [REFERENCE_DATA_MUTATIONS.TOGGLE_IS_LOADING](
    state: IReferenceDataState,
    isLoading: boolean
  ): void {
    state.isLoading = isLoading;
  },
  [REFERENCE_DATA_MUTATIONS.SET_REFERENCE_DATA](
    state: IReferenceDataState,
    value: IReferenceDataTypes
  ) {
    state.data = value;
  },
  [REFERENCE_DATA_MUTATIONS.ADD_REFERENCE_DATA_ITEM](
    state: IReferenceDataState,
    { type, referenceDataItem }
  ) {
    state.data[type].items = [...state.data[type].items, referenceDataItem];
  },
  [REFERENCE_DATA_MUTATIONS.SET_ADD_NEW_DIALOG_ERROR_MESSAGE](state, message) {
    // Show a more user friendly error message if possible
    if (Array.isArray(message)) {
      message = message.map(error => error.errorMessage).join(", ");
    }

    state.addNewDialogErrorMessage = message;
  },
  [REFERENCE_DATA_MUTATIONS.SET_BANKS_DATA](
    state: IReferenceDataState,
    banksData
  ) {
    state.banks = banksData;
  },
  [REFERENCE_DATA_MUTATIONS.SET_DATA_TABLE_PAGINATION](state, value) {
    state.dataTable.pagination = value;
  }
};
